<template>
  <div class="field-section">
    <label class="text-caption grey--text text--darken-2">
      <slot name="label">
        <v-icon
          v-if="label && isRestrict && $store.state.auth.user.token"
          size="10px"
          color="grey darken-0"
          style="margin-bottom: 2px"
          >mdi-lock</v-icon
        >
        {{ label }}
      </slot>
    </label>
    <div class="subtitle-2">
      <restrict-chip :value="value">
        <restrict-icon
          :labeled="true"
          :label="label"
          :is-restrict="isRestrict"
        />
        <slot name="value">
          <span v-if="value">{{ value }}</span>
          <i v-else class="text-caption grey--text text--darken-1">
            {{ $t("sem_informacoes") }}
          </i>
        </slot>
      </restrict-chip>
    </div>
  </div>
</template>

<script>
import RestrictChip from "@/components/chips/restrict-chip";
import RestrictIcon from "@/components/icons/restrict-icon";
export default {
  components: { RestrictIcon, RestrictChip },
  props: {
    isRestrict: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
    value: {
      type: String,
    },
  },
};
</script>

<style scoped></style>
